<template>
    <div>
        <span :class="{'cs-redLabel':data.IsAmountChange}">{{ data.Amount + data.AmountTax | toCurrency }}<span v-if="data.AmountTax > 0">(税{{data.AmountTax | toCurrency}})</span></span>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>

export default {
  props: {
    data: {},
    columnData:{},
    status: {}
  },
  data() {
    return {
    }
  },
  components: {},
  created() {
    
  },
  methods: {
    
  },
  watch: {
    data: function() {
      
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/accountListAmountCell.vue